import { capitalize } from "lodash";

export function snakeCaseToName(snakeCaseValue: string): string {
  return capitalize(snakeCaseValue.split("_").join(" "));
}
